import * as mathUtil from '@/common/js/mathutil.js'

export default {
  title: 'Add integers with unlike signs',
  operation: 'solve-simple-input',
  config: { nProblems: 10, maxPlaces: 4 },
  problem: function () {
    // a + b = c
    var sign = mathUtil.randomSign()
    var a = mathUtil.randomIntUniform(1, 9) * sign
    var b = mathUtil.randomIntUniform(1, 9) * -sign
    var c = a + b

    var lhsTex = (sign > 0) ? a + '+(' + b + ')' : '(' + a + ')+' + b

    // question
    var question = []
    question.push({ type: 'string', value: 'Add.' })

    // answers
    var answers = []
    answers.push({ before: '$' + lhsTex + '=$', value: c })

    // explanation
    var steps = []
    if (a === -b) {
      steps.push('The sum of two opposite numbers is zero.')
    } else {
      steps.push('When adding integers with different signs, <br>' +
                 'find the difference of the absolute values and <br>take the sign of the larger absolute value.')
      steps.push('Find the difference of ' + Math.abs(a) + ' and ' + Math.abs(b) + ' to get ' + Math.abs(c) + '<br>' +
                 'and take the sign of ' + (Math.abs(a) > Math.abs(b) ? a : b) + '.')
    }
    steps.push('$' + lhsTex + '=' + c + '$')

    return { question: question, answers: answers, explanation: steps }
  }
}



// WEBPACK FOOTER //
// ./src/math/drills/int/intbxpt.js